import React from 'react';
import MyProgress from '../Dashboard/MyProgress/MyProgress';
import UserInfo from '../Dashboard/UserInfo/UserInfo';
import MarketingTrackerPreview from './MarketingTrackerPreview';
import MarketingGoalsPreview from './MarketingGoalsPreview';
import MarketingLessonPreview from './MarketingLessonPreview';
import MarketingHeader from './MarketingHeader';
import { demoDashboardState, MARKETING_PROFILE_IMAGE_URL } from './marketingDemoData';
import '../Dashboard.css';
import './MarketingAssets.css';

/**
 * Purpose-built "What's Inside" composite — one header, daily tools left,
 * Breakthrough lesson right. No scale hacks.
 */
const MarketingWhatsInsidePreview = () => (
    <div className="marketing-v1-shell marketing-whats-inside">
        <MarketingHeader />
        <div className="marketing-whats-inside__body">
            <div className="marketing-whats-inside__daily">
                <div className="marketing-whats-inside__profile">
                    <UserInfo
                        AllState={demoDashboardState}
                        AllStateChange={() => {}}
                        getCustomerProfileInformation={() => {}}
                        achievementsLoading={false}
                        PublicProfile={1}
                        profileImageUrl={MARKETING_PROFILE_IMAGE_URL}
                    />
                    <MyProgress
                        AllState={demoDashboardState}
                        AllStateChange={() => {}}
                        myProgressLoading={false}
                    />
                </div>
                <div className="marketing-whats-inside__tools">
                    <MarketingTrackerPreview activeTab="daily" />
                    <MarketingGoalsPreview />
                </div>
            </div>
            <div className="marketing-whats-inside__lesson">
                <MarketingLessonPreview
                    embedded
                    showHeader={false}
                    compact
                />
            </div>
        </div>
    </div>
);

export default MarketingWhatsInsidePreview;
